export default {
  PAGE_WIZARD: 'page-wizard',
  GENERATE_BLOCK: 'generate-block',
  AI_ONBOARDING: 'ai-onboarding',
  SITE_WIZARD: 'site-wizard',
  GENERATE_PAGE_COPY: 'generate-page-copy',
};
